<template>
  <div id="recover-wrapper">
    <div class="bg-ball-cyan"></div>
    <div class="bg-ball-blue"></div>

    <div class="recover-general-card">
      <div class="recover-form-step-wrapper" v-if="isForm == true">
        <div class="recover-logo-container">
          <button
            class="recover-logo-btn"
            type="button"
            @click="handlePageChange('landing')"
          >
            <picture>
              <source srcset="../assets/img/logo-MEC.webp" type="image/webp" />
              <source srcset="../assets/img/logo-MEC.png" type="image/png" />
              <img
                src="../assets/img/logo-MEC.png"
                alt="Logo MEC"
                width="76"
                height="42"
              />
            </picture>
          </button>
        </div>
        <h3 class="recover-title txt-bold">¿Tienes problemas para entrar?</h3>
        <p class="recover-txt">
          Introduce tu correo electrónico y te enviaremos un enlace para que
          vuelvas a entrar en tu cuenta.
        </p>
        <form class="recover-form" @submit.prevent="handleRecover">
          <label class="recover-label" for="recover-email">
            <input
              id="recover-email"
              class="recover-input"
              :class="{ 'recover-invalid-input': errors.correo }"
              type="email"
              placeholder="Escribe tu correo electrónico"
              v-model="formRecover.correo"
              ref="recoverEmail"
            />
            <p v-if="errors.correo" class="recover-invalid-feedback txt-bold">
              {{ errors.correo }}
            </p>
          </label>
          <label class="recover-label" for="recover-captcha">
            <img
              class="recover-captcha-img"
              :src="captchaSource"
              alt="Captcha"
            />
            <div class="recover-reload-captcha-container">
              <button
                type="button"
                class="recover-reload-captcha-btn"
                @click="getCaptcha"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="currentColor"
                  class="bi bi-arrow-counterclockwise"
                  viewBox="0 0 16 16"
                >
                  <defs>
                    <linearGradient
                      id="grad3"
                      x1="0%"
                      y1="0%"
                      x2="100%"
                      y2="0%"
                    >
                      <stop
                        offset="0%"
                        style="stop-color: rgb(0, 246, 187); stop-opacity: 1"
                      />
                      <stop
                        offset="100%"
                        style="stop-color: rgb(29, 143, 206); stop-opacity: 1"
                      />
                    </linearGradient>
                  </defs>
                  <path
                    fill="url(#grad3)"
                    d="M8 3a5 5 0 1 1-4.546 2.914.5.5 0 0 0-.908-.417A6 6 0 1 0 8 2v1z"
                  />
                  <path
                    fill="url(#grad3)"
                    d="M8 4.466V.534a.25.25 0 0 0-.41-.192L5.23 2.308a.25.25 0 0 0 0 .384l2.36 1.966A.25.25 0 0 0 8 4.466z"
                  />
                </svg>
              </button>
            </div>
            <input
              id="recover-captcha"
              class="recover-input"
              type="text"
              :class="{ 'recover-invalid-input': errors.captcha }"
              placeholder="Digita el captcha"
              v-model="formRecover.cvt"
              ref="recoverCaptcha"
            />
          </label>
          <p v-if="errors.captcha" class="recover-invalid-feedback txt-bold">
            {{ errors.captcha }}
          </p>

          <p class="recover-invalid-feedback txt-bold" ref="errorGeneral">
            {{ errors.general }}
          </p>

          <div class="recover-btns-container">
            <button
              class="recover-submit-btn"
              type="submit"
              data="Enviar"
              :disabled="sending"
            >
              <div class="lds-ring" v-if="sending">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </button>
            <button
              class="recover-back-btn txt-bold"
              type="button"
              @click="goBack"
            >
              Volver
            </button>
          </div>
        </form>
      </div>

      <div class="recover-msg-step-wrapper" v-else>
        <div class="recover-logo-container">
          <button
            class="recover-logo-btn"
            type="button"
            @click="handlePageChange('landing')"
          >
            <picture>
              <source srcset="../assets/img/logo-MEC.webp" type="image/webp" />
              <source srcset="../assets/img/logo-MEC.png" type="image/png" />
              <img
                src="../assets/img/logo-MEC.png"
                alt="Logo MEC"
                width="76"
                height="42"
              />
            </picture>
          </button>
        </div>

        <h3 class="recover-title txt-bold">Correo enviado exitosamente</h3>

        <p class="recover-txt">
          Revisa tu correo electrónico y sigue los pasos para restablecer tu
          contraseña.
        </p>

        <div class="recover-btns-container">
          <button
            class="recover-grad-btn"
            type="button"
            @click="goBack"
            data="Volver a Inicio"
          ></button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MEC_Funcionarios_api from "@/modules/MEC_Funcionarios_api";

export default {
  data() {
    return {
      isForm: true,
      errors: {},
      focusError: [],
      captchaSource: "",
      sending: false,
      formRecover: {
        cvt: "",
        vckey: "",
        correo: "",
      },
    };
  },

  mounted() {
    this.getCaptcha();
  },

  methods: {
    async handleRecover() {
      const apiFuncionarios = new MEC_Funcionarios_api();
      this.sending = true;

      if (!this.validateRecoverForm()) {
        return;
      }

      await apiFuncionarios
        .getRecoverPassword(this.formRecover)
        .then((result) => {
          this.sending = false;
          console.log(result);
          if (result.data.info) {
            this.isForm = false;
          } else if (result.data.error) {
            this.errors.general = true;
            this.$refs.errorGeneral.textContent = "Captcha Incorrecto";
          } else {
            this.errors.general = true;
            this.$refs.errorGeneral.textContent = "Ha ocurrido un error";
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    validateRecoverForm() {
      this.errors = {};
      this.focusError = [];

      // Regular Expression para comprobar que el email sea valido
      const emailRe =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      this.formRecover.correo = this.formRecover.correo.trim();
      this.formRecover.cvt = this.formRecover.cvt.trim();

      if (!this.formRecover.correo) {
        this.errors.correo = "Debes ingresar un correo electrónico";
        this.focusError.push("recoverEmail");
      } else if (!emailRe.test(this.formRecover.correo)) {
        this.errors.correo = "Debes ingresar un correo electrónico válido";
        this.focusError.push("recoverEmail");
      }

      if (!this.formRecover.cvt) {
        this.errors.captcha = "Debes digitar el captcha";
        this.focusError.push("recoverCaptcha");
      }

      if (this.focusError.length > 0) {
        this.focusInput(this.focusError[0]);
      }

      return Object.keys(this.errors).length === 0;
    },

    async getCaptcha() {
      const apiFuncionarios = new MEC_Funcionarios_api();
      this.formRecover.cvt = "";

      await apiFuncionarios
        .getCaptcha()
        .then((result) => {
          this.formRecover.vckey = result.data.vckey;
          this.captchaSource = result.data.source;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    focusInput(inputRef) {
      this.$nextTick(() => {
        this.$refs[inputRef].focus();
      });
    },

    goBack() {
      this.$emit("pageBack", { lastPage: "recover" });
    },

    handlePageChange(page) {
      this.$emit("pageChange", { page, lastPage: "recover" });
    },
  },
};
</script>

<style>
/* ---------------------------------------------- Contenedor general Recuperacion de Contraseña */
#recover-wrapper {
  height: 100%;
  width: 100%;
  overflow-y: auto;
  background-color: var(--bg-color);
  /* background-image: url("../assets/img/MEC-bg-image-1.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center; */
}

/* ---------------------------------------------- Contenedor interno Recuperacion de Contraseña */
.recover-general-card {
  margin: 40px auto;
  width: 90%;
  max-width: 560px;
  min-height: 400px;
  padding: 30px 60px;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 5;
}

.recover-msg-step-wrapper,
.recover-form-step-wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.recover-logo-container {
  margin: 70px 0;
  width: 100%;
  display: flex;
  justify-content: center;
}

.recover-logo-btn {
  all: unset;
  cursor: pointer;
  transition: transform 0.3s ease-in-out;
}

.recover-logo-btn:focus {
  transform: scale(1.1);
}

.recover-title {
  font-size: 20px;
  color: var(--white);
  text-align: center;
}

.recover-txt {
  margin: 2rem 0;
  color: var(--white);
  text-align: center;
}

/* ---------------------------------------------- Estilos formulario de Recuperacion de Contraseña */
.recover-form {
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  width: 90%;
  max-width: 300px;
  gap: 1rem;
}

.recover-label {
  width: 100%;
  color: var(--white);
  font-weight: 700;
  display: flex;
  flex-direction: column;
  gap: 10px;
  position: relative;
}

.recover-captcha-img {
  width: 80%;
  align-self: center;
}

.recover-reload-captcha-container {
  position: relative;
  width: 100%;
  height: 0;
}

.recover-reload-captcha-btn {
  outline: none;
  border: none;
  cursor: pointer;
  background-color: transparent;
  position: absolute;
  right: 0;
  top: -75px;
}

.recover-input {
  outline: none;
  padding: 0 1rem;
  width: 100%;
  height: 48px;
  background: var(--input-bg);
  border: 1px solid var(--input-border);
  border-radius: 15px;
  color: var(--white);
}

.recover-input::placeholder {
  color: var(--input-border);
}

.recover-input:focus {
  border: 1px solid var(--accent-color);
  box-shadow: 0 0 0.5rem 1px #49fffcbc;
}

.recover-invalid-feedback {
  margin: 0;
  color: red;
  font-size: 12px;
  width: 100%;
  text-align: center;
}

.recover-invalid-input {
  border: 1px solid red;
}

.recover-invalid-input:focus {
  border: 1px solid red;
  box-shadow: 0 0 1rem 5px #ff5c5cbc;
}

.recover-error-txt {
  margin: 0;
  width: 100%;
  color: red;
  text-align: center;
}

.recover-btns-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 30px;
  align-items: center;
}

.recover-back-btn {
  outline: none;
  border: none;
  background: transparent;
  margin-bottom: 50px;
  width: 130px;
  height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--white);
  border-radius: 15px;
  transition: color 0.3s ease-in-out;
}

.recover-back-btn:hover {
  color: var(--hover-white);
}

.recover-submit-btn {
  outline: none;
  border: none;
  background-image: var(--grad-color-2);
  width: 130px;
  height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--white);
  gap: 0.5rem;
  border-radius: 15px;
  position: relative;
}

.recover-submit-btn:disabled {
  background-image: none;
  cursor: not-allowed;
  background-color: var(--input-border);
  color: var(--input-border);
}

.recover-grad-btn {
  outline: none;
  border: none;
  background-image: var(--grad-color-2);
  width: 160px;
  height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--white);
  border-radius: 15px;
  position: relative;
}

.recover-grad-btn:focus,
.recover-submit-btn:focus {
  outline: 1px solid #fff;
  outline-offset: 2px;
}

.recover-grad-btn::before,
.recover-submit-btn::before {
  content: "";
  position: absolute;
  top: 2px;
  right: 2px;
  bottom: 2px;
  left: 2px;
  background-color: var(--input-bg);
  border-radius: 13px;
  transition: background 0.3s ease-in-out;
}

.recover-grad-btn::after,
.recover-submit-btn::after {
  content: attr(data);
  font-size: 16px;
  font-weight: 700;
  color: var(--white);
  z-index: 10;
}

.recover-submit-btn:disabled::after {
  color: var(--input-border);
}

.recover-submit-btn:disabled .lds-ring div {
  border: 4px solid var(--input-border);
  border-color: var(--input-border) transparent transparent transparent;
}
.recover-grad-btn:hover::before,
.recover-submit-btn:hover::before {
  background-color: transparent;
}
</style>
